/* eslint-disable no-shadow */
import { get } from '@utils/api';
import { GET_ZIP_CODE_FROM_STORE, GET_LOAD_STATUS } from '../../types/getters';
import { FETCH_AVAILABILITY } from '../../types/actions';
// import MockBopsavailabilityData from '../../../mocks/bcom/bopsavailable.json';

/**
 * @typedef {Object} AvailabilityStoreState
 * @property {Record<string, any>} data
 * @property {boolean} isDataLoaded
 */

/**
 *
 * @param {string} productId
 * @param {number | null} storeLocation
 * @param {number | null} zipCode
 * @returns
 */
const buildUrl = (productId, storeLocation, zipCode) => {
  const pathName = `/xapi/digital/v1/product/${productId}/store/bopsavailable`;
  /** @type {Record<string, number>} */
  const params = {};

  if (storeLocation) params._storeLocation = storeLocation;
  if (zipCode) params.sddZipCode = zipCode;

  const queryString = Object.keys(params)
    .map((key) => `${key}=${encodeURIComponent(params[key])}`)
    .join('&');

  return `${pathName}${queryString ? `?${ queryString}` : ''}`;
};

/**
 * @returns {AvailabilityStoreState}
 */
export function state() {
  return {
    data: {},
    isDataLoaded: false,
  };
}

export const getters = {
  /**
   * @param {AvailabilityStoreState} state
   */
  [GET_ZIP_CODE_FROM_STORE]: (state) => state.data?.store?.address?.zipCode || '',
  /**
   * @param {AvailabilityStoreState} state
   */
  [GET_LOAD_STATUS]: (state) => state.isDataLoaded,
};

export const mutations = {
  /**
   * @param {AvailabilityStoreState} state
   */
  setData(state, result = {}) {
    state.data = result;
  },

  /**
   * @param {AvailabilityStoreState} state
   * @param {boolean} [status]
   */
  setLoadStatus(state, status = true) {
    state.isDataLoaded = status;
  },
};

export const actions = {
  /**
   *
   * @param {import('vuex').ActionContext<AvailabilityStoreState, Object>} param0
   * @param {{
   * storeLocation: number | null,
   * zipCode: number | null,
   * productId: string,
   * }} param1
   */
  async [FETCH_AVAILABILITY](
    { commit },
    {
      storeLocation = null,
      zipCode = null,
      productId = '',
    },
  ) {
    if (!productId) {
      throw new Error('productId is required');
    }

    const url = buildUrl(productId, storeLocation, zipCode);
    const result = await get(url);

    const bopsavailabilityData = result || { productStoreBopsAvailable: {} };

    commit('setData', bopsavailabilityData?.productStoreBopsAvailable || {});
    // To test with mocked data
    // commit('setData', MockBopsavailabilityData);
    commit('setLoadStatus');
  },
};
